import styled from 'styled-components';
import sizes from 'styles/sizes';
import colors from 'styles/colors';
import media from 'styles/media';

export const HeaderBackground = styled.div`
	background-color: ${colors.functional.blue};
	position: relative;
`;

export const HeaderConstrain = styled.div`
	max-width: ${sizes.constrains.desktop + sizes.gutter.large * 2}px;
	margin: 0 auto;
`;

export const PageBackground = styled.div`
	position: fixed;
	height: 100vh;
	width: 100%;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: linear-gradient(180deg, #ffffff 0%, #ebedf0 100%);
	pointer-events: none;
`;

export const PromoWrapper = styled.div`
	margin: 0 5px 0 0;
`;

export const SearchBarConstrain = styled.div`
	margin: 0 ${sizes.gutter.large}px;

	${media.medium`
    margin: 0 ${sizes.gutter.small}px;
  `}
`;

export const PageConstrain = styled.div<{ isMaxWidth: boolean }>`
	${(props) =>
		props.isMaxWidth &&
		`
	 max-width: ${sizes.constrains.desktop + sizes.gutter.large * 2}px;
 `}
	padding-bottom: 30px;
	margin: 0 auto;
	opacity: 0;

	&.compare {
		${PromoWrapper} {
			display: none;
		}

		${SearchBarConstrain} {
			display: none;
		}
	}
`;

export const ToolBarContainer = styled.div`
	border-bottom: solid 1px rgba(255, 255, 255, 0.16);

	${media.medium`
    display: none
  `}
`;
